<template>
  <section id="platform" class="h25-section alt">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Platform</div>
        <h2>赋能中台 — 三大核心能力</h2>
        <p>产品内容持续输出、全程支撑/赋能、实施运维交付兜底，构成创势赋能渠道伙伴的核心底盘</p>
      </div>
      <div class="card-row">
        <div class="h25-card" v-for="card in cards" :key="card.icon">
          <div class="c-icon">{{ card.icon }}</div>
          <h4>{{ card.title }}</h4>
          <p class="c-desc">{{ card.desc }}</p>
          <ul><li v-for="(item,i) in card.items" :key="i" v-html="item"></li></ul>
        </div>
      </div>
      <div style="text-align:center;margin-top:40px">
        <span class="h25-btn-primary" @click="goAnchor('contact')">立即咨询 →</span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'PlatformSection',
  inject:['goAnchor'],
  data(){ return { cards: [
    { icon:'📦', title:'产品弹药库', desc:'AI产品内容持续输出，分层矩阵供给伙伴前端拓客', items:['<strong>入门引流</strong> — 产品单页·海报·短视频·FAQ','<strong>标准成交</strong> — 标准化PPT·方案·报价·案例集','<strong>高阶攻坚</strong> — 定制方案·竞品对比·深度拆解'] },
    { icon:'🤝', title:'专业售前陪跑', desc:'四步闭环全程配合伙伴上门洽谈与项目攻坚', items:['<strong>线索研判</strong> — 行业·需求·预算精准研判，输出方案','<strong>客户对接</strong> — 线上宣讲演示 + 线下上门陪谈','<strong>方案输出</strong> — 快速输出标准化/定制方案及报价','<strong>成交攻坚</strong> — 标书撰写·竞品对标·答辩支撑','2小时响应 · 24小时出方案 · 一对一专属对接'] },
    { icon:'🛡️', title:'实施运维兜底', desc:'签约后全权承接，现场部署+安装调试+培训+长期售后', items:['<strong>前期部署</strong> — 账号搭建·系统部署·设备安装·功能调试','<strong>落地培训</strong> — 管理者+一线员工分层教学','<strong>试运行保障</strong> — 定期巡检·实时监测·及时调优','<strong>验收归档</strong> — 标准化资料·报告·档案完整闭环','分级响应 · 主动运维 · 知识库持续沉淀'] }
  ] } }
}
</script>
<style scoped>
.card-row { display:grid; grid-template-columns:repeat(auto-fit,minmax(320px,1fr)); gap:20px; }
.c-icon { font-size:24px; margin-bottom:18px; color:var(--h25-accent); }
h4 { font-size:18px; font-weight:700; margin-bottom:8px; color:var(--h25-text); }
.c-desc { font-size:14px; color:var(--h25-muted); margin-bottom:20px; line-height:1.7; }
ul { list-style:none; }
li { font-size:14px; padding:3px 0; color:var(--h25-text2); line-height:1.7; }
li::before { content:'— '; color:var(--h25-accent); }
</style>
